<template>
  <div>
    <v-btn icon @click="openDialog()">
      <v-icon :color="ui.btnColor">
        toggle_on
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <span>
              {{item.title}}
            </span>
            <v-spacer/>
            <span class="hidden-xs-only">
              {{result.basic.id}}
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row>
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>{{item.icon}}</v-icon>
                </v-avatar>
                {{item.heading}}
              </v-chip>
            </span>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="item.tag !== 'C1' && item.tag !== 'F1'">
              {{item.tag}}
            </v-chip>
          </v-layout>
          <v-container>
            <v-layout class="text-xs-left ml-2 mr-2" v-if="this.tag === 'A1'">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> fingerprint </v-icon>
                </v-avatar>
                Tag
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{result.basic.id}}
              </v-chip>
            </v-layout>
            <div v-if="this.tag === 'C1'">
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> pin </v-icon>
                  </v-avatar>
                  ABN
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.abn}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_tree </v-icon>
                  </v-avatar>
                  Structure
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.struct}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_tree </v-icon>
                  </v-avatar>
                  {{result.char.struct}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> factory </v-icon>
                  </v-avatar>
                  Industry
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.area}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> factory </v-icon>
                  </v-avatar>
                  {{result.char.area}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> mail </v-icon>
                  </v-avatar>
                  Contact
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.epri}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> mail </v-icon>
                  </v-avatar>
                  {{result.char.epri}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> call </v-icon>
                  </v-avatar>
                  Phone
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.ppri}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> call </v-icon>
                  </v-avatar>
                  {{result.char.ppri}}
                </v-chip>
              </v-layout>
            </div>
            <div v-if="this.tag === 'F1'">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view</v-icon>
                  </v-avatar>
                  Theme
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.theme}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view</v-icon>
                  </v-avatar>
                  {{result.char.theme}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> factory </v-icon>
                  </v-avatar>
                  Type
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> factory </v-icon>
                  </v-avatar>
                  {{result.char.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> login </v-icon>
                  </v-avatar>
                  Access
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.site}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> login </v-icon>
                  </v-avatar>
                  {{result.char.site}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> priority_high </v-icon>
                  </v-avatar>
                  Risk
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.risk}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> priority_high </v-icon>
                  </v-avatar>
                  {{result.char.risk}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> warehouse </v-icon>
                  </v-avatar>
                  Output
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.out}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> warehouse </v-icon>
                  </v-avatar>
                  {{result.char.out}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> work_outline </v-icon>
                  </v-avatar>
                  Permit
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.work}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> work_outline </v-icon>
                  </v-avatar>
                  {{result.char.work}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> mail </v-icon>
                  </v-avatar>
                  Contact
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.epri}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> mail </v-icon>
                  </v-avatar>
                  {{result.char.epri}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> call </v-icon>
                  </v-avatar>
                  Phone
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.ppri}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> call </v-icon>
                  </v-avatar>
                  {{result.char.ppri}}
                </v-chip>
              </v-layout>
            </div>
            <div v-if="this.tag === 'A1'">
              <v-layout class="text-xs-left ml-2 mr-2" >
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  Technical
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{this.result.char.dis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> adjust </v-icon>
                  </v-avatar>
                  Function
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{result.char.obj}}
                </v-chip>
              </v-layout>
            </div>
          </v-container>
          <v-container class="ml-3"
          v-if="this.tag === 'C1' || this.tag === 'F1' || this.tag === 'A1'">
            <div v-if="this.tag === 'C1'">
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Company Description
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading" v-if="this.result.char.des !== ''">
                  {{result.char.des}}
                </div>
                <div :class="ui.textSubheading" v-else>
                  {{defineDocumentFromTag(item.tag).des}}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> admin_panel_settings </v-icon>
                  </v-avatar>
                  Company Users Data Privacy
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  As new Company User you agree that Company Custodian will process your personal data in accordance with Besea Data Privacy Policy. You agree that Company to which you requested access may contact you to seek additional information to support your access application.
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> sync_alt </v-icon>
                  </v-avatar>
                  Company Data Sharing
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  Company Authenticated User you will be entitled to view, share, create and modify company data in accordance with authority level granted by the Company Custodian. You must take reasonable steps and precautions to ensure that company data remains private and confidential for all business operations. Please review Besea Terms of Use and Data Privacy for additional details. The Company Custodian reserves the right to change or suspend your Company Access without notice.
                </div>
              </v-layout>
            </div>
            <div v-if="this.tag === 'F1'">
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Facility Description
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading" v-if="this.result.char.des !== ''">
                  {{result.char.des}}
                </div>
                <div :class="ui.textSubheading" v-else>
                  {{defineDocumentFromTag(item.tag).des}}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> adjust </v-icon>
                  </v-avatar>
                  Operational Objectives
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{result.char.obj}}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> admin_panel_settings </v-icon>
                  </v-avatar>
                  Facility Users Data Privacy
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  As new Facility User you agree that Facility Custodian will process your personal data in accordance with Besea Data Privacy Policy and you agree that Facility to which you requested access may contact you to seek additional information to support your access application.
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> sync_alt </v-icon>
                  </v-avatar>
                  Facility Data Sharing
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  As Facility Authenticated User will be entitled to view, share, create and modify facility operational, maintenance and engineering data in accordance with authority level granted by the Facility Custodian. Please be aware that some facility information may be confidential and you must take reasonable steps and precautions to ensure that facility data remains private and confidential for all business operations. Please review Besea Terms of Use and Data Privacy for additional details. The Facility Custodian reserves the right to change or suspend your Facility Access without notice.
                </div>
              </v-layout>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            close
          </v-btn>
          <v-spacer/>
          <div v-if="this.result.basic.tag !== 'A1'">
            <div v-if="
            this.btnSpinAccessRequest === false &&
            this.showRequestBtn === true
            ">
              <v-btn
              :color="ui.colorWarning"
              @click="accessVerifyRegister()"
              flat dark>
                <v-icon left :color="ui.colorWarning"> key </v-icon>
                  Request Access
              </v-btn>
            </div>
            <div v-else-if="btnSpinAccessRequest === true">
              <BtnSpin dark :btnSpec="btnInfo1"/>
            </div>
            <div v-else>
              <v-btn
              class="hidden-xs-only"
              :color="ui.btnColor"
              @click="closeDialog()"
              flat dark>
                <v-icon left :color="ui.btnColor"> key </v-icon>
                  Request Completed
              </v-btn>
            </div>
          </div>        
          <GetDetailPage v-if="this.item.tag === 'A1'"
          :data="{
            tag: 'A1',
            size: 'flat',
            item: this.result}"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import accessRequestFunctions from "@/support/access/mixins/accessRequestFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import GetDetailPage from "@/support/detail/components/GetDetailPage";
// import AccessRequest from "@/support/access/components/AccessRequest";
import BtnSpin from "@/frame/animation/components/BtnSpin";

export default {
  mixins: [
    apptheme,
    numberFunctions,
    storeFunctions,
    routerFunctions,
    describeDocument,
    accessRequestFunctions
  ],
  components: {
    // AccessRequest,
    GetDetailPage,
    BtnSpin
  },
  data() {
    return {
      dialog: false,
      valid: false,
      showRequestBtn: true,
      btnSpinGetRegisterList: false,
      btnSpinAccessRequest: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  computed: {
    ...mapGetters([
      "getDataSource",
      "getSearchResults",
      "getPageTitle",
      "getCardOpen"
    ]),
    result() {
      return this.getSearchResults[this.listIndex];
    },
    tag() {
      let tag = this.result.basic.tag;
      return tag;
    },
    item() {
      let obj = {
        tag: "",
        title: "",
        heading: "",
        enableSelect: false,
        enableDetail: false,
        icon: "",
        btnSpinAccessRequest: false,
        btnInfo1: {
          color: "red",
          icon: "person",
          name: "add user",
          btnType: ""
        }
      };
      if (this.result.basic.tag === "C1") {
        obj.tag = "C1";
        obj.title = "Company Access";
        obj.icon = "account_balance";
        obj.enableSelect = false;
        obj.enableDetail = false;
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "F1") {
        obj.tag = "F1";
        obj.title = "Facility Access";
        obj.icon = "place";
        obj.enableSelect = false;
        obj.enableDetail = false;
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "A1") {
        obj.tag = "A1";
        obj.title = "Asset";
        obj.icon = "emoji_transportation";
        obj.enableSelect = false;
        obj.enableDetail = false;
        obj.heading = this.result.basic.title;
      } else {
        obj.title = "Undefined";
      }
      // others
      return obj;
    }
  },
  // eslint-disable-next-line
  props: {
    listIndex: {
      type: Number
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.btnSpinGetDetail = false;
      this.btnSpinAccessRequest = false;
      // this.saveToStore(this.result);
      let did = this.result.basic.did;
      if (this.tag === "C1") {
        this.$store.dispatch("changeCompanyDID", did);
      } else if (this.tag === "F1") {
        this.$store.dispatch("changeFacilityDID", did);
      } else {
        // do nothing
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    getDetailThenPage() {
      let router = this.defineRouter(this.item.tag);
      this.$router.push(router);
      this.dialog = false;
    },
    accessVerifyRegister() {
      this.dialog = false;
      this.verifyThenRequestAccess(this.result);
    }
  }
};
</script>
